/**
 * Sprava stromu odchozich/prichozich zprav. Vsechny zpravy jsou zde ulozeny.
 * Vkladani novych zprav je pres metodu push, posle zprav je v messages.
 */
import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { nanoid } from 'nanoid';

import { useAxios } from './Axios';
import { useRelations } from './Relations';
import { History } from '../api/models';

export enum EMessageDirection {
    Incomming,
    Outcomming,
}

export enum EMessageType {
    Info,
    History,
    TextInput,
    Node
}

export interface IIncommingNode {
    nodeId: number
}

export interface IOutcommingNode {
    nodeId: number
    text: string
}

export interface IIncommingTextInput {
    qestion: string
}

export interface IIncommingInfo {
    text: string
}

export interface IOutcommingTextInput {
    text: string
}

export interface IHistory {
    text: string
}

export type MessagePayload = IIncommingNode | IOutcommingNode | IIncommingTextInput | IOutcommingTextInput | IHistory | IIncommingInfo;

export interface IMessage {
    direction: EMessageDirection
    type: EMessageType
    payload: MessagePayload
}

export interface IMessageComplete extends IMessage {
    id: string
}

interface IMessages {
    messages: Array<IMessageComplete>
    push: (msg: IMessage) => void
}

export type MessagesType = IMessages;

export const MessagesContext = createContext<MessagesType>({
    messages: [],
    push: (msg: IMessage) => { }
});

export const useMessages = () => {
    return useContext(MessagesContext);
};

interface IMessagesProps {
    children: any
}

function Messages({ children }: IMessagesProps) {
    const axios = useAxios();
    const { setId } = useRelations();
    const [messages, setMessages] = useState<IMessages['messages']>([]);

    //vkladani novych zprav - vklada se na konec seznamu
    const push = useCallback(
        (msg: IMessage) => {
            setMessages([
                ...messages,
                {
                    ...msg,
                    id: nanoid()//kazda zprava obdrzi svuj jedinecny identifikator
                }
            ]);
        },
        [messages]
    );

    //nacteni historie konverzace pro danou session id
    useEffect(
        () => {
            axios.get<History>('history')
                .then(response => {
                    const out: IMessages['messages'] = [];

                    if (response.data.chat.length) {
                        response.data.chat.forEach(({ question, answer }) => {
                            question && out.push({
                                id: nanoid(),
                                direction: EMessageDirection.Outcomming,
                                type: EMessageType.History,
                                payload: {
                                    text: question
                                }
                            });
                            answer && out.push({
                                id: nanoid(),
                                direction: EMessageDirection.Incomming,
                                type: EMessageType.History,
                                payload: {
                                    text: answer
                                }
                            });
                        });
                        setId(response.data.lastNodeId || 0);
                    }
                    else if(response.data.lastNodeId) {
                        out.push({
                            id: nanoid(),
                            direction: EMessageDirection.Incomming,
                            type: EMessageType.Node,
                            payload: {
                                nodeId: response.data.lastNodeId
                            }
                        });
                    }

                    setMessages(out);
                });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    return (
        <MessagesContext.Provider value={{ messages, push }}>
            {children}
        </MessagesContext.Provider>
    );
}

export default Messages;
